import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

const CERTIFY_ROLES = new Set([
  'reviewer',
  'registrar',
  'judge',
  'court_admin',
  'super_admin',
  'magistrate',
]);

const REGENERATE_ROLES = new Set([
  'reviewer',
  'registrar',
  'judge',
  'court_admin',
  'super_admin',
  'magistrate',
]);

const RECORD_ROLES = new Set([
  'registrar',
  'judge',
  'court_admin',
  'super_admin',
  'magistrate',
]);

const COURTROOM_ROLES = new Set(['registrar', 'reviewer', 'judge', 'magistrate']);
const COURT_ADMIN_ROLES = new Set(['court_admin', 'super_admin']);
const SUPER_ADMIN_ROLES = new Set(['super_admin']);

export const usePermissions = () => {
  const { user } = useAuth();

  return useMemo(() => {
    const role = String(user?.role || 'guest').toLowerCase().replace(/\s+/g, '_');

    return {
      role,
      displayRole: role.replace(/_/g, ' '),
      canCertify: CERTIFY_ROLES.has(role),
      canRequestRegeneration: REGENERATE_ROLES.has(role),
      canRecord: RECORD_ROLES.has(role),
      isCourtroomUser: COURTROOM_ROLES.has(role),
      isCourtAdmin: role === 'court_admin',
      isSuperAdmin: role === 'super_admin',
      isAdmin: COURT_ADMIN_ROLES.has(role),
      canManageUsers: COURT_ADMIN_ROLES.has(role),
      canManageTenants: SUPER_ADMIN_ROLES.has(role),
      canViewAuditLog: COURT_ADMIN_ROLES.has(role),
      canViewRegenReport: COURT_ADMIN_ROLES.has(role),
      canAccessCourtAdmin: COURT_ADMIN_ROLES.has(role),
      canAccessSuperAdmin: SUPER_ADMIN_ROLES.has(role),
    };
  }, [user?.role]);
};

export default usePermissions;
